import $ from "./ajax";

export class Api{
	commonRequest(url, page, number, query){
			let requestData = {
				p : (page == null || page == undefined) ? 0 : page,
				n : (number !== null || number !== undefined) ? number : 16 ,
				s : (query == null || query == undefined) ? undefined : query,
				o : 'date_created',
				od : 'desc',
				"X-login-id" : TVSite.loginId,
				status : "approved"
			};
			
			if(!!window.TVSiteFilter){
				if(TVSiteFilter.brand){
					requestData["brand"] = TVSiteFilter.brand;	
				}
			}
			return $.ajax({
				url : url,
				cache : false,
				dataType : "jsonp",
				data : requestData
        });
	}
	commonClean(url, page, number,query){
		let requestData = {
			p : (page == null || page == undefined) ? 0 : page,
			n : (number !== null || number !== undefined) ? number : 12,
			s : (query == null || query == undefined) ? undefined : query,
			"X-login-id" : TVSite.loginId,
			status : "approved"
		};
		
		return $.ajax({
			url : url,
			cache : false,
			dataType : "jsonp",
			data : requestData
		});
	}
	filters(){
        return $.ajax({
            url: TVSite.apiUrl + 'codebook/display/video',
            dataType: 'jsonp',
            data: {
                'X-login-id': TVSite.loginId,
                channelId: TVSite.channelId
            }
        });
    }
    videoInfo(videoId){
		const url = TVSite.apiUrl+"videos/"+ videoId +"/channels";
        return this.commonRequest(url,null,null)
	}
	products(videoId){
        var url = TVSite.apiUrl+"videos/" + videoId + "/products";
        return this.commonRequest(url, null, null, null);
	}
	suggestKeywords(page, query){
		const url = TVSite.apiUrl + 'videos/search/suggest?';
		return this.commonClean(url, page, query);
	}
	suggestResults(page, query, number){
		const url = TVSite.apiUrl + "videos/search";
		return this.commonClean(url, page, number, query);
	}
	channelInfo(channelId){
        var url = TVSite.apiUrl+"channels/"+channelId;
        return this.commonRequest(url,null,null,null)
	}
	videos(channelId, page,number,query){
		var url = TVSite.apiUrl+"videos/search";
		var search = query;
		if(TVSite.replacedChannel)
			channelId = TVSite.replacedChannel;
		if(channelId !== undefined && channelId !== null)
			url = TVSite.apiUrl +"channels/"+ channelId + "/videos";
		return this.commonRequest(url,page,number,search);
	}

}

export default new Api();
